const KLARNA_SUPPLIER_ALLOWLIST = new Set([
  'f4d8ba32-df5a-4bad-bf94-cf0a1c89e109', // SFF
  '57c41f0a-eab9-47da-b653-0759a238d488', // Agri Exotic, Inc.
]);

export const isKlarnaEnabledForSupplier = (supplierUUID: string): boolean =>
  KLARNA_SUPPLIER_ALLOWLIST.has(supplierUUID);
